import type {
  BlockInteractionsBlockBy,
  BlockInteractionsBlockingTypes,
  LinkEditBy,
} from '@carboncopyco/types';
import { validateUrl } from '@carboncopyco/utils';

export function getErrorLabel(
  elementType: BlockInteractionsBlockingTypes,
  findBy?: BlockInteractionsBlockBy,
  isFindAndReplace = false
) {
  const titleMsg = `with this title are already ${
    isFindAndReplace ? 'replace' : 'blocked'
  } edit it from the Manager.`;
  const isLinkElement = elementType === 'link';
  const titleError = `${isLinkElement ? 'Links' : 'Buttons'} ${titleMsg}`;

  if (findBy === 'title') {
    return titleError;
  }
  if (isLinkElement && findBy === 'url') {
    return `Links with this URL are already ${
      isFindAndReplace ? 'replace' : 'blocked'
    }. edit it from the Manager.`;
  }
  return null;
}

// validate if the url is a valid url address and not internal
export const isValidExternalUrl = (url: string): boolean => {
  try {
    new URL(url);
    return validateUrl(url);
  } catch (_err) {
    return false;
  }
};

export const getSelectorTypeToValue = (
  elementMetadata: Partial<HTMLButtonElement & HTMLAnchorElement>
): Record<LinkEditBy, string> => ({
  url: elementMetadata?.href,
  title: elementMetadata?.textContent,
});
